var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed z-10 w-full"},[_c('v-alert',{attrs:{"type":_vm.type_alert,"dense":"","value":_vm.synced_is_open}},[_vm._v(" "+_vm._s(_vm.text_alert)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }